import joi from 'joi';
import { Record as record } from 'immutable';
import config from '../../config';
import { resolve, construct } from '../../helpers/LinkMapper';
import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';

import Photo from '../Photo';

const customerTitles = config.get('customerTitles') || [];
const defaults = {
    title: customerTitles[0],
    firstNames: null,
    surname: null,
    photo: new Photo(),
    hasPhotoChanged: false,
    hasInfoChanged: false,
    isFlexi: false
};

class STicketDelivery extends record(defaults) {
    static fromJSON(json) {
        return construct(STicketDelivery, json, {
            photo: resolve(json.photo).with(Photo) || new Photo(),
            title: json.title,
            firstNames: json.firstNames,
            surname: json.surname,
            isFlexi: json.isFlexi
        });
    }

    getSchema() {
        let schema = {
            title: validators.title(),
            firstNames: validators.name(2, 50),
            surname: validators.name(2, 50),
            photo: joi.any().when('isFlexi', {
                is: true,
                then: joi.any(),
                otherwise: joi.object().keys({ imageData: validators.requiredString() }),
            }),
            isFlexi: joi.boolean(),
        };

        return schema;
    }

    getValue(property) {
        return property in defaults ? this[property] : null;
    }
}

Object.assign(STicketDelivery.prototype, ValidationMixin);

export default STicketDelivery;



// WEBPACK FOOTER //
// ./src/records/sticket/STicketDelivery.js